import { animated, useSpring } from '@react-spring/web';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useCallback, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import useWindowSize from '../../hooks/useWindowSize';

import { usePopup } from '../../contexts/PopupContext';

import FullButton from '../buttons/Full';
import CookiesForm from '../partials/CookiesForm';

import styles from '../../../styles/modals/cookies.scss';
import useConsent from '../../hooks/useConsent';

const propTypes = {
    // theme: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const CookiesPopup = ({ color, onClose, className }) => {
    const [collapsed, setCollapsed] = useState(true);
    const { closePopupWithoutCookie } = usePopup();
    const { width } = useWindowSize();
    const height = width > 700 ? 275 : 'auto';

    const onClickClose = useCallback(() => {
        closePopupWithoutCookie(null);
    }, [closePopupWithoutCookie, onClose]);

    const { onClickAccept, onClickDeny } = useConsent({ onClose: onClickClose });

    const onClickPrivacyPage = useCallback(() => {
        setCollapsed(true);
    }, [setCollapsed]);

    const formSpring = useSpring({
        height: collapsed ? 0 : height,
    });

    const buttonsSpring = useSpring({
        opacity: collapsed ? 1 : 0,
        height: collapsed ? 'auto' : 0,
    });

    const handleClick = useCallback(() => {
        setCollapsed(!collapsed);
    }, [setCollapsed, collapsed]);

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [styles.open]: !collapsed,
                    [className]: className !== null,
                },
            ])}
            style={{ backgroundColor: color }}
        >
            <div className={styles.content}>
                <div className={styles.top}>
                    <div className={styles.summary}>
                        <h3 className={styles.title}>
                            <FormattedMessage
                                id="content.cookies.title"
                                defaultMessage="Vos paramètres de confidentialité"
                            />
                        </h3>
                        <p className={styles.description}>
                            <FormattedMessage
                                id="content.cookies.description"
                                defaultMessage="Nous utilisons des témoins de connexion (cookies) pour améliorer votre expérience sur notre site et optimiser nos efforts de marketing. En acceptant, vous consentez à l'utilisation de ces témoins."
                            />{' '}
                            <Link to="/politique-de-confidentialite" className={styles.underline}>
                                <FormattedMessage
                                    id="content.cookies.read"
                                    defaultMessage="Lire notre politique de confidentialité."
                                />
                            </Link>
                        </p>
                    </div>
                    <div className={styles.buttons}>
                        <animated.div className={styles.acceptDeny} style={buttonsSpring}>
                            <FullButton className={styles.button} onClick={onClickAccept}>
                                <FormattedMessage
                                    id="content.cookies.accept"
                                    defaultMessage="Tout accepter"
                                />
                            </FullButton>
                            <FullButton className={styles.button} onClick={onClickDeny}>
                                <FormattedMessage
                                    id="content.cookies.deny"
                                    defaultMessage="Tout rejeter"
                                />
                            </FullButton>
                        </animated.div>
                        <FullButton className={styles.button} onClick={handleClick}>
                            {collapsed ? (
                                <FormattedMessage
                                    id="content.cookies.params"
                                    defaultMessage="Paramètres"
                                />
                            ) : (
                                <FormattedMessage
                                    id="content.cookies.params"
                                    defaultMessage="Paramètres"
                                />
                            )}
                            {collapsed ? ' ↑' : ' ↓'}
                        </FullButton>
                    </div>
                </div>
                <animated.div style={formSpring}>
                    <CookiesForm onClose={onClickClose} onPrivacyPage={onClickPrivacyPage} />
                </animated.div>
            </div>
        </div>
    );
};

CookiesPopup.propTypes = propTypes;
CookiesPopup.defaultProps = defaultProps;

export default CookiesPopup;
